import styled from 'styled-components';

export const Container = styled('div')`
  position: relative;
  max-width: 1000px;
  margin: auto;
`;
